/**
 * WordPress dependencies
 */
import { createBlock, parseWithAttributeSchema, rawHandler, serialize } from '@wordpress/blocks';
const transforms = {
  from: [{
    type: 'block',
    blocks: ['core/pullquote'],
    transform: _ref => {
      let {
        value,
        citation,
        anchor,
        fontSize,
        style
      } = _ref;
      return createBlock('core/quote', {
        citation,
        anchor,
        fontSize,
        style
      }, parseWithAttributeSchema(value, {
        type: 'array',
        source: 'query',
        selector: 'p',
        query: {
          content: {
            type: 'string',
            source: 'html'
          }
        }
      }).map(_ref2 => {
        let {
          content
        } = _ref2;
        return createBlock('core/paragraph', {
          content
        });
      }));
    }
  }, {
    type: 'block',
    blocks: ['core/group'],
    transform: (_ref3, innerBlocks) => {
      let {
        anchor
      } = _ref3;
      return createBlock('core/quote', {
        anchor
      }, innerBlocks);
    }
  }, {
    type: 'prefix',
    prefix: '>',
    transform: content => createBlock('core/quote', {}, [createBlock('core/paragraph', {
      content
    })])
  }, {
    type: 'raw',
    schema: () => ({
      blockquote: {
        children: '*'
      }
    }),
    selector: 'blockquote',
    transform: node => {
      return createBlock('core/quote', // Don't try to parse any `cite` out of this content.
      // * There may be more than one cite.
      // * There may be more attribution text than just the cite.
      // * If the cite is nested in the quoted text, it's wrong to
      //   remove it.
      {}, rawHandler({
        HTML: node.innerHTML,
        mode: 'BLOCKS'
      }));
    }
  }, {
    type: 'block',
    isMultiBlock: true,
    blocks: ['*'],
    isMatch: (_ref4, blocks) => {
      let {} = _ref4;
      return !blocks.some(_ref5 => {
        let {
          name
        } = _ref5;
        return name === 'core/quote';
      });
    },
    __experimentalConvert: blocks => createBlock('core/quote', {}, blocks.map(block => createBlock(block.name, block.attributes, block.innerBlocks)))
  }],
  to: [{
    type: 'block',
    blocks: ['core/pullquote'],
    isMatch: (_ref6, block) => {
      let {} = _ref6;
      return block.innerBlocks.every(_ref7 => {
        let {
          name
        } = _ref7;
        return name === 'core/paragraph';
      });
    },
    transform: (_ref8, innerBlocks) => {
      let {
        citation,
        anchor,
        fontSize,
        style
      } = _ref8;
      return createBlock('core/pullquote', {
        value: serialize(innerBlocks),
        citation,
        anchor,
        fontSize,
        style
      });
    }
  }, {
    type: 'block',
    blocks: ['core/group'],
    transform: (_ref9, innerBlocks) => {
      let {
        citation,
        anchor
      } = _ref9;
      return createBlock('core/group', {
        anchor
      }, citation ? [...innerBlocks, createBlock('core/paragraph', {
        content: citation
      })] : innerBlocks);
    }
  }, {
    type: 'block',
    blocks: ['*'],
    transform: (_ref10, innerBlocks) => {
      let {
        citation
      } = _ref10;
      return citation ? [...innerBlocks, createBlock('core/paragraph', {
        content: citation
      })] : innerBlocks;
    }
  }]
};
export default transforms;
//# sourceMappingURL=transforms.js.map